import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  ProductBase,
  ProductById,
  ProductCreatePayload,
  ProductUpdatePayload,
  ProductItem,
  ProductItemListParams,
} from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/product`;

export const getItemList = async (params?: ProductItemListParams): Promise<ApiResponse<ProductItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<ProductItem[]>>(`${BASE}/item-list`, { params });
  return data;
};

export const getList = async (params?: RequestParams): Promise<ApiResponseList<ProductBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<ProductBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<ProductById>> => {
  const { data } = await axiosInstance.get<ApiResponse<ProductById>>(`${BASE}/show`, { params: { id } });
  return data;
};

export const create = async (payload: ProductCreatePayload): Promise<ApiResponse<ProductById>> => {
  const { data } = await axiosInstance.post<ApiResponse<ProductById>>(`${BASE}/create`, payload);
  return data;
};

export const update = async (payload: ProductUpdatePayload): Promise<ApiResponse<ProductById>> => {
  const { data } = await axiosInstance.post<ApiResponse<ProductById>>(`${BASE}/update`, payload);
  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/delete`, { id });
  return data;
};
